import React, { type ReactNode } from 'react';
import { Col, theme, Typography } from 'antd';

/** Copied from `LocationSummary.tsx` to fix error of component created on render */
export const LocationListItem = ({
  title,
  content,
}: {
  title: string;
  content: ReactNode;
}) => {
  const { token } = theme.useToken();

  return (
    <Col style={{ color: token.colorTextSecondary }}>
      <Typography.Text
        strong
        style={{ color: token.colorTextSecondary, marginRight: token.marginXS }}
      >
        {title}:
      </Typography.Text>
      {content}
    </Col>
  );
};
